export const lightColors = {
  // ── Surfaces ──
  surface: "#fff",
  surfacePanel: "#fff",
  surfaceElevated: "#fff",
  inputBg: "#fff",
  snow: "#fafafa",
  dropdownBg: "#f8f9fa",

  // ── Text ──
  textMain: "#000",
  textSecondary: "#4b5563",
  textMuted: "#6b7280",
  textSubtle: "rgba(0, 0, 0, 0.5)",
  textTertiary: "rgba(0, 0, 0, 0.3)",
  textPlaceholder: "#9ca3af",
  textDisabled: "#9ca3af",

  // ── Legacy names ──
  black: "#000",
  black50: "#808080",
  black05: "rgba(0, 0, 0, 0.05)",
  whiteSmoke: "#f2f2f2",
  lightgrey03: "rgba(225, 226, 230, 0.3)",
  infoHighlightBg: "#e0f2fe",

  // ── Borders & dividers ──
  formBorder: "#d1d5db",
  lightgrey: "#e1e2e6",
  divider: "rgba(0, 0, 0, 0.1)",
  modalBorderColor: "rgba(0, 0, 0, 0.2)",

  // ── Greys ──
  darkGrey: "#9a9a9a",
  darkGrey05: "rgba(154,154,154, 0.5)",
  grey: "#c8c9cc",
  greyInactive: "#b9babb",
  grey75: "rgba(200, 201, 204, 0.75)",

  // ── Icons ──
  iconDefault: "#c8c9cc",

  // ── Primary ──
  primary: "#3e82f7",
  primaryDark: "#1d4ed8",
  primaryDarkest: "#193463",
  primaryLight: "#2681ff",
  primaryAccent: "#255aca",
  primaryPale: "rgb(231, 239, 254)",
  primary05: "rgba(62, 130, 247, 0.5)",
  primary10: "rgba(62, 130, 247, 0.1)",

  // ── Secondary ──
  secondary: "#1fd983",
  secondaryLight: "#5af0a8",
  secondary05: "rgba(31, 217, 131, 0.5)",

  // ── Semantic colors ──
  red: "#ff5d5f",
  red05: "rgba(255, 93, 95, 0.5)",
  // Error copy at 13px needs more contrast than `red` gives on light surfaces.
  errorText: "#d6383a",
  green: "#49A430",
  lightgreen: "#1fd983",
  yellow: "#fea33f",
  yellow05: "rgba(254, 223, 124, 0.5)",

  // ── Status ──
  pending: "#ffaf5d",
  cancel: "#ff5d5f",
  success: "#1fd983",

  // ── Social (fixed across modes) ──
  fb: "#4460a0",
  vk: "#5181b8",
  mairu: "#168ee2",

  // ── Focus ──
  focusRing: "rgba(59, 130, 246, 0.15)",
  errorFocusRing: "rgba(255, 93, 95, 0.15)",
  fieldFocusBorder: "#3e82f7",
  fieldFocusShadow: "0 0 0 4px rgba(59, 130, 246, 0.15)",

  // ── Overlays ──
  overlay: "rgba(0, 0, 0, 0.8)",
  overlayLight: "rgba(0, 0, 0, 0.5)",
  overlayMedium: "rgba(0, 0, 0, 0.42)",
  overlayBlurScrim: "rgba(255, 255, 255, 0.45)",

  // ── Shadows ──
  shadowColor: "rgba(0, 0, 0, 0.15)",
  shadowColorLight: "rgba(0, 0, 0, 0.05)",
  panelShadow: "-10px 0 20px 0 rgba(0, 0, 0, 0.05)",

  // ── Elevated surfaces ──
  elevatedText: "rgba(0, 0, 0, 0.75)",
  modalTextLight: "rgba(0, 0, 0, 0.4)",
  modalCloseHover: "rgba(0, 0, 0, 0.8)",

  // ── Interaction ──
  hoverBg: "#e1f0ff",
  subtleHover: "rgba(0, 0, 0, 0.05)",
  skeletonBg: "#e2e5e9",

  // ── Fade masks & gradients (auto-derived from `surface` in buildTheme) ──
  fadeMask: "rgba(255, 255, 255, 0.95)",
  fadeMaskTransparent: "rgba(255, 255, 255, 0)",
  surfaceOverlay60: "rgba(255, 255, 255, 0.6)",
  surfaceGradient:
    "linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.85) 15%, rgba(255, 255, 255, 1) 30%)",

  // ── Row & selection highlights ──
  rowBg: "rgba(255, 255, 255, 0.45)",
  rowMetaText: "#000",
  selectedRowBg: "rgba(228, 234, 245, 0.45)",
  checkedRowBg: "#f2f5fa",

  // ── Component tokens ──
  imageViewerOverlay: "rgba(255, 255, 255, 0.75)",
  addressPurple: "#8a5bf9",
  filterPillBg: "#485179",
  parcelIconColor: "#C8C9CC",
  accentText: "#000",
  codeBlockBg: "#f2f2f2",
  deliveryGradientEnd: "#f6f6f7",
  refundBg: "#d0f3ae",
  booksBg: "rgba(225, 226, 230, 0.25)",

  // ── Badge ──
  badgeBg: "#fff7ed",
  badgeText: "#c2410c",
  badgeBorder: "#fed7aa",

  // ── Warning ──
  warningBg: "#fff8e6",
  warningBorder: "#e6a800",
  warningText: "#6b5200",

  // ── Dashboard/Mailbox sections ──
  sectionBannerDark: "#404480",
  sectionBannerLight: "#f2f1f8",
  sectionBannerAlt: "#404040",
  primaryLightest: "#e8e8f4",

  // ── Surface texture ──
  surfaceTextureDot: "rgba(0, 0, 0, 0.052)",

  // ── Auth pages ──
  authText: "#333",

  // ── Package type icons ──
  packageBoxBg: "#FADDA1",
  packageBagBg: "#BED6FA",
  packageBagDot: "#18327C",
  packageCustomsBg: "#B3E3C2",

  // ── Button ──
  buttonPrimary: "#3e82f7",
  buttonSecondary: "#1fd983",
  buttonFilledText: "#fff",
  buttonFilledShadow: "0 3px 10px 0",
  buttonLightBgThreshold: 0.7,

  // ── Toast ──
  toastShadow: "0 3px 10px 0",

  // ── Layout ──
  contentShadow: "none",
  navBorder: "0.5px solid #c8c9cc",
  headerBorder: "none",
  rowBorder: "#c8c9cc",

  // ── Nav text ──
  navText: "#000",

  // ── KB articles (components/KbArticle → --sabo-* variables) ──
  articleSurface: "#ffffff",
  articleText: "#1a1a1a",
  articleTextMuted: "#5c5c5c",
  articleAccent: "#1b4332",
  articleAccentLight: "#e8f0ec",
  articleBorder: "#e2dfd9",
  articleRule: "#d4cfc6",
  articleSectionNum: "#95917e",

  // ── Active state (tabs + menu) ──
  activeBg: "#e0f2fe",
  activeText: "#1d4ed8",
  activeShadow: "none",
  activeTextShadow: "none",
  activeBorder: "none",
};

export const darkColors: typeof lightColors = {
  // ── Surfaces ──
  surface: "#131214",
  surfacePanel: "#1f1e20",
  surfaceElevated: "#1c1d1f",
  inputBg: "#1c1d1f",
  snow: "#161517",
  dropdownBg: "#222224",

  // ── Text ──
  textMain: "#ffffff",
  textSecondary: "#949494",
  textMuted: "#949494",
  textSubtle: "rgba(255, 255, 255, 0.5)",
  textTertiary: "rgba(255, 255, 255, 0.3)",
  textPlaceholder: "#5a5a5c",
  textDisabled: "#4a4a4c",

  // ── Legacy names ──
  black: "#ffffff",
  black50: "#949494",
  black05: "rgba(255, 255, 255, 0.05)",
  whiteSmoke: "#1c1d1f",
  lightgrey03: "rgba(50, 50, 52, 0.3)",
  infoHighlightBg: "rgba(185, 177, 250, 0.12)",

  // ── Borders & dividers ──
  formBorder: "#2e2e30",
  lightgrey: "#2e2e30",
  divider: "rgba(255, 255, 255, 0.1)",
  modalBorderColor: "rgba(255, 255, 255, 0.15)",

  // ── Greys ──
  darkGrey: "#6a6a6c",
  darkGrey05: "rgba(106, 106, 108, 0.5)",
  grey: "#3a3a3c",
  greyInactive: "#4a4a4c",
  grey75: "rgba(58, 58, 60, 0.75)",

  // ── Icons ──
  iconDefault: "#636363",

  // ── Primary ──
  primary: "#b9b1fa",
  primaryDark: "#a49cf0",
  primaryDarkest: "#8f87e0",
  primaryLight: "#c9c2ff",
  primaryAccent: "#a49cf0",
  primaryPale: "rgba(185, 177, 250, 0.15)",
  primary05: "rgba(185, 177, 250, 0.5)",
  primary10: "rgba(185, 177, 250, 0.15)",

  // ── Secondary ──
  secondary: "#22e88f",
  secondaryLight: "#5af0a8",
  secondary05: "rgba(34, 232, 143, 0.5)",

  // ── Semantic colors ──
  red: "#ff6b6d",
  red05: "rgba(255, 107, 109, 0.5)",
  errorText: "#ff6b6d",
  green: "#5ab840",
  lightgreen: "#22e88f",
  yellow: "#ffb355",
  yellow05: "rgba(255, 179, 85, 0.5)",

  // ── Status ──
  pending: "#ffb970",
  cancel: "#ff6b6d",
  success: "#22e88f",

  // ── Social (fixed) ──
  fb: "#4460a0",
  vk: "#5181b8",
  mairu: "#168ee2",

  // ── Focus ──
  focusRing: "rgba(185, 177, 250, 0.25)",
  errorFocusRing: "rgba(255, 107, 109, 0.2)",
  fieldFocusBorder: "transparent",
  fieldFocusShadow: "0 0 0 0.5px #ffffff",

  // ── Overlays ──
  overlay: "rgba(0, 0, 0, 0.85)",
  overlayLight: "rgba(0, 0, 0, 0.6)",
  overlayMedium: "rgba(0, 0, 0, 0.6)",
  overlayBlurScrim: "rgba(19, 18, 20, 0.55)",

  // ── Shadows ──
  shadowColor: "rgba(0, 0, 0, 0.25)",
  shadowColorLight: "rgba(0, 0, 0, 0.15)",
  panelShadow: "none",

  // ── Elevated surfaces ──
  elevatedText: "rgba(255, 255, 255, 0.85)",
  modalTextLight: "rgba(255, 255, 255, 0.4)",
  modalCloseHover: "rgba(255, 255, 255, 0.8)",

  // ── Interaction ──
  hoverBg: "rgba(185, 177, 250, 0.15)",
  subtleHover: "rgba(255, 255, 255, 0.05)",
  skeletonBg: "#222224",

  // ── Fade masks & gradients (auto-derived from `surface` in buildTheme) ──
  fadeMask: "rgba(19, 18, 20, 0.95)",
  fadeMaskTransparent: "rgba(19, 18, 20, 0)",
  surfaceOverlay60: "rgba(19, 18, 20, 0.6)",
  surfaceGradient:
    "linear-gradient(to bottom, rgba(19, 18, 20, 0) 0%, rgba(19, 18, 20, 0.85) 15%, rgba(19, 18, 20, 1) 30%)",

  // ── Row & selection highlights ──
  rowBg: "rgba(28, 29, 31, 0.45)",
  rowMetaText: "#949494",
  selectedRowBg: "rgba(185, 177, 250, 0.15)",
  checkedRowBg: "#202123",

  // ── Component tokens ──
  imageViewerOverlay: "rgba(19, 18, 20, 0.85)",
  addressPurple: "#b9b1fa",
  filterPillBg: "#2e2e30",
  parcelIconColor: "#949494",
  accentText: "#7cbc61",
  codeBlockBg: "#1c1d1f",
  deliveryGradientEnd: "#161517",
  refundBg: "rgba(90, 200, 60, 0.2)",
  booksBg: "rgba(255, 255, 255, 0.04)",

  // ── Badge ──
  badgeBg: "rgba(255, 179, 85, 0.15)",
  badgeText: "#ffb355",
  badgeBorder: "rgba(255, 179, 85, 0.3)",

  // ── Warning ──
  warningBg: "rgba(255, 179, 85, 0.1)",
  warningBorder: "#ffb355",
  warningText: "#ffcc80",

  // ── Dashboard/Mailbox sections ──
  sectionBannerDark: "#1c1d1f",
  sectionBannerLight: "#161517",
  sectionBannerAlt: "#2a2a2c",
  primaryLightest: "rgba(185, 177, 250, 0.12)",

  // ── Surface texture ──
  surfaceTextureDot: "rgba(255, 255, 255, 0.052)",

  // ── Auth pages ──
  authText: "#bcbcbd",

  // ── Package type icons ──
  packageBoxBg: "#949494",
  packageBagBg: "#949494",
  packageBagDot: "#18327C",
  packageCustomsBg: "#949494",

  // ── Button ──
  buttonPrimary: "#b9b1fa",
  buttonSecondary: "#ffffff",
  buttonFilledText: "#fff",
  buttonFilledShadow: "none",
  buttonLightBgThreshold: 0.45,

  // ── Toast ──
  toastShadow: "none",

  // ── Layout ──
  contentShadow: "none",
  navBorder: "none",
  headerBorder: "none",
  rowBorder: "#2e2e30",

  // ── Nav text ──
  navText: "#bcbcbd",

  // ── KB articles ──
  articleSurface: "#1c1d1f",
  articleText: "#e6e4df",
  articleTextMuted: "#a09d97",
  articleAccent: "#74c69d",
  articleAccentLight: "rgba(116, 198, 157, 0.14)",
  articleBorder: "rgba(255, 255, 255, 0.12)",
  articleRule: "rgba(255, 255, 255, 0.18)",
  articleSectionNum: "#807c72",

  // ── Active state ──
  activeBg: "#1f1e20",
  activeText: "#ffffff",
  activeShadow: "none",
  activeTextShadow: "none",
  activeBorder: "none",
};

export type ThemeColors = typeof lightColors;

// Runtime allowlist of theme tokens. Used by partner config schema to reject
// typos in theme.light / theme.dark (e.g. `primery` would otherwise parse
// cleanly as z.record(string,string) and silently fail to apply).
export const KNOWN_THEME_KEYS = Object.keys(lightColors) as ReadonlyArray<
  keyof ThemeColors
>;
